module.exports = __webpack_public_path__ + "static/img/jumper_ff_20-1.d00f536.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/jumper_ff_20-1.svg
// module id = f40t
// module chunks = 0